<template>

    <div :class="$mapStep.type=='poiDetail' || $BRT.$options.PoiListDrawer == 3 ? 'brt-brtmap half':'brt-brtmap'" ref="brtmap"></div>

</template>

<script>

    export default {
        name: "Brtmap",

        data(){
            return{}
        },

        mounted(){

            this.$refs['brtmap'].appendChild($VAR.container);

            //移除中转节点
            if(document.getElementById('brtmapDOM') && document.getElementById('brtmapDOM').parentNode){
                document.getElementById('brtmapDOM').parentNode.removeChild(document.getElementById('brtmapDOM'));
            }


            let $this = this,
                $plugInfo = $this.$store.state.mapStore.plugInfo.plugInfo,
                $brtmap = $this.$store.state.mapStore.brtmap;
                $brtmap.map = {};

                let callback = ()=>{

                    if($brtmap.$urlParam.share.poiId){

                        $this.$BRT.$mapStep.type = 'selectePOI';
                        $this.$mapStep.poiID = $brtmap.$urlParam.share.poiId;
                        $this.$set($brtmap.$urlParam.share,'status',true);

                    }else if(this.$BRT.$urlParam.shopActive.status){

                        if(this.$store.state.ACTIVITY_DATA.length == 0){

                            this.$message.info('暂无企业活动');

                            this.$message.load(false);

                            this.$BRT.$urlParam.shopActive.status = false;
                        }

                    }

                    $brtmap.ready = true;
                }

                if($VAR.map.mapInfoArray){
                    callback && callback()
                }else{
                    $VAR.map.on('floorend',()=>{
                        if(!$brtmap.ready){
                            callback && callback()
                        }
                    })
                }

                /*

                let _callback = ()=>{
                    setTimeout(()=>{//防止数据未准备好

                        //地图链接操作准备
                        if($brtmap.$urlParam.share.poiId){

                            setTimeout(()=>{

                                $this.$BRT.$mapStep.type = 'selectePOI';
                                $this.$mapStep.poiID = $brtmap.$urlParam.share.poiId;
                                $this.$set($brtmap.$urlParam.share,'status',true);

                            },0)

                            // $brtmap.$urlParam.share.status = true;

                        }else if(this.$BRT.$urlParam.shopActive.status){   //店铺活动

                            if(this.$store.state.ACTIVITY_DATA.length == 0){

                                this.$message.info('暂无店铺活动');

                                this.$message.load(false);

                                this.$BRT.$urlParam.shopActive.status = false;
                            }
                        }

                        setTimeout(()=>{
                            $brtmap.ready = true;    //开启相关组件
                        },10)

                    },1000)
                }

                //检测原因，其他使用地图地图页面进入 mapready不执行
                $VAR.map.mapInfoArray ? _callback() : $VAR.map.on('mapready',()=>{_callback()});

                 */

        }
    }
</script>



<style lang="less">

    @import "Brtmap.less";

</style>
